import {
  FacetCriteria,
  FacetsInOrderCriteria,
  PlpCatalog,
  CatalogParams,
  OrderCriteria,
  PageNumberCriteria,
  AppliedFacets,
} from '@/types/plp'
import AlgoliaPlp from '@/scripts/libs/algolia/plp'

export interface ProductListPageHelper {
  getAppliedFacets(): AppliedFacets

  getAppliedOrderCriteria(): undefined | string

  mapOrderCriteria(_: null | string): OrderCriteria

  mapPageNumberCriteria(_: string): PageNumberCriteria

  mapFacetCriteria(_: AppliedFacets): FacetCriteria

  mapFacetsInOrderCriteria(_: AppliedFacets): FacetsInOrderCriteria

  /* TODO: Extract interface */
  fetchAppliedFacetsRecap(_: AppliedFacets): Promise<any>

  fetchCatalog(_: CatalogParams): Promise<PlpCatalog>
  /* TODO: Extract interface */
  fetchMoreProducts(_: any): Promise<PlpCatalog>

  facetIsActive(_: string, __: string): boolean

  loadProductsByPageNumber({
    pageNumber,
    nextPageURL,
    dispatch,
  }: {
    pageNumber: number
    nextPageURL: string
    dispatch: (action: string, params?: any) => void
  }): void

  getPriceSortOptions(): Array<string>

  getCrosslinksFromCategoryNames(): Promise<
    Array<{
      categoryName: string
      href: string
      label: string
    }>
  >

  actionsAreVisible(): boolean
  getIsPlpTilesExploded(): boolean
}

export default AlgoliaPlp
